import { gql } from '@apollo/client'
import { DRAW_MAP_TASK_FRAGMENT } from '../fragments/DrawMapTaskFragment'

export const GET_DRAW_MAP_TASK = gql`
  query GetDrawMapTask($taskId: ID!) {
    getDrawMapTask(taskId: $taskId) {
      ...DrawMapTask
    }
  }
  ${DRAW_MAP_TASK_FRAGMENT}
`
